import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import {
  deleteReq,
  patch,
  useGet,
  usePatch,
  usePost,
} from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateCoupon = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/${activeStore}/coupons/create`);
};

export const useGetCoupons = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(`/users/${activeStore}/coupons/list/${queryData}`);
  return data;
};

export const useGetCouponData = (couponId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(couponId ? `/users/${activeStore}/coupons/${couponId}` : null);
};

export const useUpdateCoupon = (couponId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(`/users/${activeStore}/coupons/${couponId}`);
};

export const useDeleteCoupon = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (couponId: number) => {
      return deleteReq(`/users/${activeStore}/coupons/${couponId}`);
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};

export const useUpdateCouponStatus = () => {
  const activeStore = useSelector(getActiveStoreId);
  const handleStatusChange = useCallback(
    (couponId: number, status: boolean) => {
      return patch(`/users/${activeStore}/coupons/${couponId}/status`, {
        status,
      });
    },
    [activeStore]
  );
  return useFetchAsync(handleStatusChange);
};
